<template>
  <div class="airST-conditional-card" v-bind="$attrs">
    <div v-if="title" class="airST-conditional-title">
      <button
        :class="{ show: show }"
        type="button"
        @click="$emit('toggle-collapse')"
      >
        {{ title }}
      </button>
    </div>
    <!-- use slot to place content of card -->
    <div v-show="show" class="airST-conditional-contents">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterConditionCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: this.show,
    }
  },
}
</script>
